import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    addIcon: {
      fontSize: "2.5rem",
    },
    addMerchant: {
      width: "100%",
      height: "100%",
      display: "flex",
      minHeight: 240,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "transparent",
      cursor: "pointer",
      border: "2px dashed black",
      transition: "0.3s",
      [theme.breakpoints.down("xs")]: {
        minHeight: "unset",
      },
      "&:hover": {
        backgroundColor: "white",
        border: `2px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
      },
    },
  }),
);

const useAppDashedAddButton = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useAppDashedAddButton as default };
